import React from "react";

function HelpBlockIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="13"
      height="13"
      fill="none"
      viewBox="0 0 13 13"
    >
      <g clipPath="url(#clip0_590_2556)">
        <path
          stroke="#fff"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.296"
          d="M5.145 4.803a1.54 1.54 0 012.991.513c0 1.026-1.54 1.539-1.54 1.539m.042 2.052h.005m5.126-2.565a5.13 5.13 0 11-10.262 0 5.13 5.13 0 0110.262 0z"
        ></path>
      </g>
      <defs>
        <clipPath id="clip0_590_2556">
          <path
            fill="#fff"
            d="M0 0H12.314V12.314H0z"
            transform="translate(.481 .185)"
          ></path>
        </clipPath>
      </defs>
    </svg>
  );
}

export default HelpBlockIcon;